// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"442":"418899e6","563":"bded07c5"}[chunkId] + ".chunk.js";
};